import React from "react";
import { TableColumn } from "components/pages/measurement-devices/utils/types";
import { DataTableValue, DataTable as Table, DataTableProps as TableProps } from "primereact/datatable";
import { Column } from "primereact/column";
import { T } from "services/lang/LanguageService";

type DataTableProps<T extends DataTableValue> = {
  columns: TableColumn<T>[];
  data: T[];
  tableConfig?: TableProps<T[]>
};

const DataTable = <T extends DataTableValue>({ columns, data, tableConfig }: DataTableProps<T>) => {
  return (
    <Table
      value={data}
      stripedRows
      paginator
      rows={10}
      reorderableColumns
      rowsPerPageOptions={[5, 10, 25, 50]}
      paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
      currentPageReportTemplate={T("table.page-report-template", {
        first: "{first}",
        last: "{last}",
        totalRecords: "{totalRecords}",
      })}
      size="small"
      className="overflow-x-auto"
      {...tableConfig}
    >
      {columns.map(col => (
        <Column key={col.columnKey} {...col} />
      ))}
    </Table>
  );
}

export default DataTable;